import * as React from 'react';
import { PayAndPublishContainer } from '../ActionButtonsDesktop/components';
import { SaveDraftContainer } from '../SaveDraft';
import * as styles from './HiddenBaseMobile.css';

export const HiddenBaseMobile = () => {
  return (
    <>
      <SaveDraftContainer />

      <div className={styles['publish_button']}>
        <PayAndPublishContainer />
      </div>
    </>
  );
};
